import React, { useState } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import ProfileHeader from './components/ProfileHeader';
import PersonalDetailsForm from './components/PersonalDetailsForm';
import AcademicDetailsSection from './components/AcademicDetailsSection';
import CertificationsSection from './components/CertificationsSection';
import SkillsAssessmentSection from './components/SkillsAssessmentSection';
import ProjectsSection from './components/ProjectsSection';
import DocumentUploadSection from './components/DocumentUploadSection';
import CompletionSuggestions from './components/CompletionSuggestions';
import Icon from '../../components/AppIcon';

const StudentProfileManagement = () => {
  const [activeTab, setActiveTab] = useState('personal');
  const [isSaving, setIsSaving] = useState(false);

  const [profileData] = useState({
    name: 'Moumita Sinha',
    email: 'moumita.sinha@example.com',
    phone: '+91 98765 43210',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a5bd625c-1763296116639.png",
    avatarAlt: 'Professional headshot of young Indian woman with long black hair wearing blue formal blazer'
  });

  const [personalDetails, setPersonalDetails] = useState({
    fullName: 'Moumita Sinha',
    dateOfBirth: '2002-05-15',
    gender: 'female',
    email: 'moumita.sinha@example.com',
    phone: '+91 98765 43210',
    alternatePhone: '',
    address: 'Flat 301, Sunrise Apartments, Andheri West',
    city: 'Mumbai',
    state: 'maharashtra',
    pincode: '400058',
    careerPreference: ['full-time', 'internship'],
    linkedin: 'https://linkedin.com/in/moumitasinha',
    portfolio: 'https://moumitasinha.dev'
  });

  const [errors, setErrors] = useState({});

  const [academicData, setAcademicData] = useState([
  {
    degree: 'Bachelor of Technology (B.Tech)',
    institution: 'Mumbai University Institute of Technology',
    specialization: 'Computer Science and Engineering',
    startYear: '2020',
    endYear: '2024',
    grade: '8.5',
    gradeType: 'cgpa'
  },
  {
    degree: 'Higher Secondary Certificate (HSC)',
    institution: 'St. Xavier\'s College',
    specialization: 'Science',
    startYear: '2018',
    endYear: '2020',
    grade: '92.5',
    gradeType: 'percentage'
  }]
  );

  const [certifications, setCertifications] = useState([
  {
    name: 'AWS Certified Cloud Practitioner',
    issuer: 'Amazon Web Services',
    issueDate: '2023-08-15',
    credentialId: 'AWS-CCP-2023-8765',
    credentialUrl: 'https://aws.amazon.com/verification/AWS-CCP-2023-8765'
  },
  {
    name: 'Google Analytics Individual Qualification',
    issuer: 'Google',
    issueDate: '2023-06-20',
    credentialId: 'GAIQ-2023-4321',
    credentialUrl: 'https://skillshop.exceedlms.com/student/award/GAIQ-2023-4321'
  },
  {
    name: 'React - The Complete Guide',
    issuer: 'Udemy',
    issueDate: '2023-03-10',
    credentialId: 'UC-REACT-2023',
    credentialUrl: ''
  }]
  );

  const [skills, setSkills] = useState([
  { name: 'React.js', category: 'technical', proficiency: 4 },
  { name: 'JavaScript', category: 'technical', proficiency: 4 },
  { name: 'Python', category: 'technical', proficiency: 3 },
  { name: 'Node.js', category: 'technical', proficiency: 3 },
  { name: 'MongoDB', category: 'technical', proficiency: 3 },
  { name: 'Communication', category: 'soft', proficiency: 4 },
  { name: 'Team Collaboration', category: 'soft', proficiency: 4 },
  { name: 'Problem Solving', category: 'soft', proficiency: 5 },
  { name: 'English', category: 'language', proficiency: 5 },
  { name: 'Hindi', category: 'language', proficiency: 5 },
  { name: 'Marathi', category: 'language', proficiency: 4 },
  { name: 'Git & GitHub', category: 'tools', proficiency: 4 },
  { name: 'VS Code', category: 'tools', proficiency: 5 },
  { name: 'Figma', category: 'tools', proficiency: 3 }]
  );

  const [projects, setProjects] = useState([
  {
    title: 'E-Commerce Platform',
    description: 'Built a full-stack e-commerce platform with React, Node.js, and MongoDB. Implemented features like user authentication, product catalog, shopping cart, and payment integration using Razorpay. Achieved 99.9% uptime and handled 1000+ concurrent users.',
    technologies: 'React, Node.js, Express, MongoDB, Razorpay, JWT',
    startDate: '2023-06-01',
    endDate: '2023-09-30',
    projectUrl: 'https://ecommerce-demo.moumitasinha.dev',
    githubUrl: 'https://github.com/moumitasinha/ecommerce-platform'
  },
  {
    title: 'Task Management Application',
    description: 'Developed a collaborative task management tool with real-time updates using Socket.io. Features include task assignment, priority levels, deadline tracking, and team collaboration. Implemented drag-and-drop functionality for intuitive task organization.',
    technologies: 'React, Socket.io, Node.js, PostgreSQL, Tailwind CSS',
    startDate: '2023-01-15',
    endDate: '2023-04-20',
    projectUrl: 'https://taskmanager.moumitasinha.dev',
    githubUrl: 'https://github.com/moumitasinha/task-manager'
  },
  {
    title: 'Weather Forecast Dashboard',
    description: 'Created a responsive weather dashboard that displays current weather and 7-day forecasts using OpenWeatherMap API. Implemented location-based weather detection and interactive charts for temperature and precipitation visualization.',
    technologies: 'React, Chart.js, OpenWeatherMap API, CSS3',
    startDate: '2022-11-01',
    endDate: '2022-12-15',
    projectUrl: 'https://weather.moumitasinha.dev',
    githubUrl: 'https://github.com/moumitasinha/weather-dashboard'
  }]
  );

  const [documents, setDocuments] = useState([
  {
    id: 1,
    type: 'resume',
    name: 'Aritra_Dasgupta_Resume_2024.pdf',
    size: 245678,
    uploadDate: '2024-01-15T10:30:00',
    status: 'uploaded'
  },
  {
    id: 2,
    type: 'marksheet',
    name: 'B.Tech_Semester_7_Marksheet.pdf',
    size: 189234,
    uploadDate: '2024-01-10T14:20:00',
    status: 'uploaded'
  },
  {
    id: 3,
    type: 'certificate',
    name: 'AWS_Cloud_Practitioner_Certificate.pdf',
    size: 156789,
    uploadDate: '2023-08-20T09:15:00',
    status: 'uploaded'
  }]
  );

  const [completionPercentage] = useState(85);

  const [suggestions] = useState([
  {
    title: 'Add More Certifications',
    description: 'Showcase additional certifications to strengthen your profile',
    priority: 'medium',
    action: 'certifications',
    actionLabel: 'Add Certification'
  },
  {
    title: 'Upload ID Proof',
    description: 'Complete verification by uploading a government-issued ID',
    priority: 'high',
    action: 'documents',
    actionLabel: 'Upload Document'
  },
  {
    title: 'Add Alternate Phone Number',
    description: 'Provide a backup contact number for better reachability',
    priority: 'low',
    action: 'personal',
    actionLabel: 'Update Contact'
  }]
  );

  const tabs = [
  { id: 'personal', label: 'Personal Details', icon: 'User' },
  { id: 'academic', label: 'Academic Details', icon: 'GraduationCap' },
  { id: 'skills', label: 'Skills Assessment', icon: 'Target' },
  { id: 'projects', label: 'Projects', icon: 'FolderGit2' },
  { id: 'documents', label: 'Documents', icon: 'FileText' }];


  const handlePersonalDetailsChange = (field, value) => {
    setPersonalDetails((prev) => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors((prev) => ({ ...prev, [field]: '' }));
    }
  };

  const handleSave = () => {
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      alert('Profile saved successfully!');
    }, 1500);
  };

  const handlePublish = () => {
    alert('Profile published successfully! Employers can now view your profile.');
  };

  const handleDownload = () => {
    alert('Resume download started. Your resume will be downloaded shortly.');
  };

  const handleAddAcademic = (entry) => {
    setAcademicData((prev) => [...prev, entry]);
  };

  const handleUpdateAcademic = (index) => {
    alert(`Edit functionality for academic entry ${index + 1} will be implemented`);
  };

  const handleDeleteAcademic = (index) => {
    if (window.confirm('Are you sure you want to delete this qualification?')) {
      setAcademicData((prev) => prev?.filter((_, i) => i !== index));
    }
  };

  const handleAddCertification = (cert) => {
    setCertifications((prev) => [...prev, cert]);
  };

  const handleDeleteCertification = (index) => {
    if (window.confirm('Are you sure you want to remove this certification?')) {
      setCertifications((prev) => prev?.filter((_, i) => i !== index));
    }
  };

  const handleAddSkill = (skill) => {
    setSkills((prev) => [...prev, skill]);
  };

  const handleUpdateSkill = (index, updates) => {
    setSkills((prev) => prev?.map((skill, i) => i === index ? { ...skill, ...updates } : skill));
  };

  const handleDeleteSkill = (index) => {
    setSkills((prev) => prev?.filter((_, i) => i !== index));
  };

  const handleAddProject = (project) => {
    setProjects((prev) => [...prev, project]);
  };

  const handleDeleteProject = (index) => {
    if (window.confirm('Are you sure you want to delete this project?')) {
      setProjects((prev) => prev?.filter((_, i) => i !== index));
    }
  };

  const handleUploadDocument = (doc) => {
    setDocuments((prev) => [...prev, doc]);
  };

  const handleDeleteDocument = (id) => {
    if (window.confirm('Are you sure you want to delete this document?')) {
      setDocuments((prev) => prev?.filter((d) => d?.id !== id));
    }
  };

  const handleSuggestionAction = (action) => {
    setActiveTab(action);
  };

  return (
    <MainLayout>
      <div className="space-y-6">
        <ProfileHeader
          profileData={profileData}
          completionPercentage={completionPercentage}
          onSave={handleSave}
          onPublish={handlePublish}
          onDownload={handleDownload}
          isSaving={isSaving} />


        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="bg-card rounded-xl shadow-warm-md border border-border overflow-hidden">
              <div className="border-b border-border overflow-x-auto scrollbar-hide">
                <div className="flex min-w-max">
                  {tabs?.map((tab) =>
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`flex items-center gap-2 px-4 md:px-6 py-4 text-sm font-medium transition-smooth flex-shrink-0 ${
                    activeTab === tab?.id ?
                    'text-primary border-b-2 border-primary bg-primary/5' : 'text-muted-foreground hover:text-card-foreground hover:bg-muted/50'}`
                    }>

                      <Icon name={tab?.icon} size={18} />
                      <span className="whitespace-nowrap">{tab?.label}</span>
                    </button>
                  )}
                </div>
              </div>

              <div className="p-4 md:p-6 lg:p-8">
                {activeTab === 'personal' &&
                <PersonalDetailsForm
                  formData={personalDetails}
                  errors={errors}
                  onChange={handlePersonalDetailsChange} />

                }

                {activeTab === 'academic' &&
                <div className="space-y-8">
                    <AcademicDetailsSection
                    academicData={academicData}
                    onAdd={handleAddAcademic}
                    onUpdate={handleUpdateAcademic}
                    onDelete={handleDeleteAcademic} />

                    <CertificationsSection
                    certifications={certifications}
                    onAdd={handleAddCertification}
                    onDelete={handleDeleteCertification} />

                  </div>
                }

                {activeTab === 'skills' &&
                <SkillsAssessmentSection
                  skills={skills}
                  onAdd={handleAddSkill}
                  onUpdate={handleUpdateSkill}
                  onDelete={handleDeleteSkill} />

                }

                {activeTab === 'projects' &&
                <ProjectsSection
                  projects={projects}
                  onAdd={handleAddProject}
                  onDelete={handleDeleteProject} />

                }

                {activeTab === 'documents' &&
                <DocumentUploadSection
                  documents={documents}
                  onUpload={handleUploadDocument}
                  onDelete={handleDeleteDocument} />

                }
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <CompletionSuggestions
              suggestions={suggestions}
              onActionClick={handleSuggestionAction} />

          </div>
        </div>
      </div>
    </MainLayout>);

};

export default StudentProfileManagement;